import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Mail, Send, LogOut, CheckCircle, AlertCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const VerifyEmailNotice = () => {
  const { user, logout, resendVerificationEmail } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResend = async () => {
    setLoading(true);
    const result = await resendVerificationEmail();
    if (result.success) {
      toast.success(result.message);
    } else {
      toast.error(result.message);
    }
    setLoading(false);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 dark:from-gray-900 dark:via-gray-800 dark:to-blue-900 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-white dark:bg-blue-500 opacity-10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-white dark:bg-blue-500 opacity-10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-md w-full relative z-10">
        <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-white/20 dark:border-gray-700 text-center">
          <div className="mb-6 flex justify-center">
            <div className="bg-blue-100 dark:bg-blue-900/30 p-4 rounded-full">
              <Mail size={48} className="text-blue-600 dark:text-blue-400" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">E-postanızı Doğrulayın</h2>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            Sistemi kullanmaya başlamak için <span className="font-semibold text-gray-900 dark:text-white">{user?.email}</span> adresine gönderdiğimiz doğrulama bağlantısına tıklamanız gerekmektedir.
          </p>

          <div className="space-y-4">
            <button
              onClick={handleResend}
              disabled={loading}
              className="w-full flex items-center justify-center bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold py-3 px-4 rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg disabled:opacity-50"
            >
              {loading ? (
                'Gönderiliyor...'
              ) : (
                <>
                  <Send size={18} className="mr-2" />
                  Doğrulama E-postasını Tekrar Gönder
                </>
              )}
            </button>

            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-semibold py-3 px-4 rounded-xl border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 transition-all"
            >
              <LogOut size={18} className="mr-2" />
              Çıkış Yap
            </button>
          </div>

          <div className="mt-8 flex items-start gap-3 p-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/50 rounded-xl text-left">
            <AlertCircle size={20} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-amber-800 dark:text-amber-300">
              E-posta kutunuzda göremiyorsanız lütfen gereksiz (spam) kutusunu kontrol edin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailNotice;
